export const sidebars = {
  's-user': {
    component: () => import( /* webpackChunkName: "sidebars" */ './s-user.vue' ),
    pos: 'right',
    meta: {
      available: true
    }
  },
  's-developer': {
    component: () => import( /* webpackChunkName: "sidebars" */ './s-developer.vue' ),
    pos: 'left',
    meta: {
      available: process.env.NODE_ENV === 'development'
    }
  },
  's-nav': {
    component: null,
    pos: 'left',
    meta: {
      available: true
    }
  }
}

const components = {}
for ( const k of Object.keys( sidebars )) {
  components[k] = sidebars[k].component
}

export {
  components
}
